<div class="wrapper">
  <div class="text-type-4 mb-[12px]">
    {{ site.site_name }} ({{ reportsList?.length || 0 }}
    report{{ reportsList?.length !== 1 ? 's' : '' }})
  </div>
  @if (reportsList?.length) {
    <div
      class="reports-list"
      [class.collapsed]="!isExpanded"
      >
      @for (report of reportsList; track report) {
        <app-site-report-card
          [report]="report"
          (click)="onClick(report)"
          />
      }
    </div>
  } @else {
    <app-site-report-card />
  }
  @if (reportsList?.length > 3) {
    <div
      class="see-more text-type-9 flex"
      (click)="isExpanded = !isExpanded"
      >
      {{ isExpanded ? 'See less' : 'See more' }}
    </div>
  }
</div>
